import { render, staticRenderFns } from "./MedicalContentTemplateEdit.vue?vue&type=template&id=97935258&scoped=true&"
import script from "./MedicalContentTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalContentTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentTemplateEdit.vue?vue&type=style&index=0&id=97935258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97935258",
  null
  
)

export default component.exports